<template>
  <div class="portada-xv" ref="rootRef" aria-label="Portada de XV">
    <div class="estrellas-container">
      <div v-for="n in 50" :key="'star-'+n" class="estrella"></div>
      <div class="estrella-fugaz f1"></div>
      <div class="estrella-fugaz f2"></div>
      <div class="estrella-fugaz f3"></div>
    </div>

    <img src="@/assets/rrm.png" class="flor flor-1" alt="" />
    <img src="@/assets/rrm.png" class="flor flor-2" alt="" />
    <img src="@/assets/rrm.png" class="flor flor-3" alt="" />

    <img src="@/assets/rrm.png" class="flor flor-4" alt="" />
    <img src="@/assets/rrm.png" class="flor flor-5" alt="" />
    <img src="@/assets/rrm.png" class="flor flor-6" alt="" />

    <img src="@/assets/disco.png" class="bola bola-izquierda" alt="" />

    <div class="imagen-xv-wrapper">
      <img src="@/assets/IMG_9604.webp" class="imagen-xv" alt="Main photo" />
    </div>

    <section class="texto-xv">
      <p class="frase-bendicion">
        With God's blessing <br />
        and my parents' love
      </p>

      <div class="separador-elegante"></div>

      <h1 class="nombre-protagonista">Leidy  &nbsp;Gaviria</h1>
      <h1 class="nombre-protagonista">Bryan  &nbsp;Zorrilla</h1>

      <p class="parrafo-presentacion">
        <br>
        Thank you, Mom and Dad, for being my roots, my strength, and my unconditional support. Today, I not only celebrate my life, but also everything you have done to shape it.
      </p>
    </section>
  </div>
</template>
<script>
import { onMounted, ref, nextTick } from 'vue'
import gsap from 'gsap'

export default {
  name: 'PortadaArley',
  setup() {
    const rootRef = ref(null)

    onMounted(async () => {
      await nextTick()

      const $ = (sel) => Array.from(gsap.utils.toArray(sel)).filter(Boolean)

      const foto = $('.imagen-xv-wrapper')
      const flores = [
        '.flor-1',
        '.flor-2',
        '.flor-3',
        '.flor-4',
        '.flor-5',
        '.flor-6'
      ].flatMap($)

      const texto = [
        '.frase-bendicion',
        '.separador-elegante',
        '.nombre-protagonista',
        '.parrafo-presentacion'
      ].flatMap($)

      gsap.set([...foto, ...flores, ...texto], { autoAlpha: 0, y: 28 })

      const io = new IntersectionObserver((entries) => {
        entries.forEach((e) => {
          if (!e.isIntersecting) return

          const tl = gsap.timeline({ defaults: { ease: 'power2.out' } })

          tl.fromTo(
            foto,
            { scale: 0.94, y: 40, filter: 'blur(6px)' },
            { autoAlpha: 1, scale: 1, y: 0, filter: 'blur(0px)', duration: 1.15 }
          )

          tl.to(
            flores,
            {
              autoAlpha: 1,
              y: 0,
              rotate: () => gsap.utils.random(-8, 6),
              duration: 0.9,
              stagger: 0.12
            },
            '-=0.6'
          )

          tl.to(texto, {
            autoAlpha: 1,
            y: 0,
            duration: 0.8,
            stagger: 0.18
          }, '-=0.3')

          flores.forEach((flor, i) => {
            gsap.to(flor, {
              y: `+=${gsap.utils.random(6, 14)}`,
              x: `+=${gsap.utils.random(-6, 6)}`,
              duration: gsap.utils.random(2.8, 4),
              repeat: -1,
              yoyo: true,
              ease: 'sine.inOut',
              delay: i * 0.2
            })
          })

          gsap.to(foto, {
            scale: 1.015,
            duration: 3.5,
            yoyo: true,
            repeat: -1,
            ease: 'sine.inOut'
          })

          io.disconnect()
        })
      }, {
        threshold: 0.15,
        rootMargin: '0px 0px -120px 0px'
      })
      if (rootRef.value) io.observe(rootRef.value)
    })

    return { rootRef }
  }
}
</script>

<style scoped>
/* ✨ ESTILOS DE CIELO ESTRELLADO */
.estrellas-container {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  z-index: 0;
  pointer-events: none;
}

.estrella {
  position: absolute;
  background: white;
  border-radius: 50%;
  opacity: 0.3;
  animation: parpadeo var(--d, 3s) infinite ease-in-out;
}

.estrella:nth-child(3n) { width: 2px; height: 2px; --d: 2s; }
.estrella:nth-child(3n+1) { width: 3px; height: 3px; --d: 4s; }
.estrella:nth-child(3n+2) { width: 1px; height: 1px; --d: 5s; }

.estrella:nth-child(1) { top: 10%; left: 20%; } .estrella:nth-child(2) { top: 15%; left: 80%; }
.estrella:nth-child(3) { top: 25%; left: 40%; } .estrella:nth-child(4) { top: 5%; left: 60%; }
.estrella:nth-child(5) { top: 40%; left: 10%; } .estrella:nth-child(6) { top: 60%; left: 90%; }
.estrella:nth-child(7) { top: 5%; left: 10%; } .estrella:nth-child(8) { top: 20%; left: 30%; }
.estrella:nth-child(9) { top: 30%; left: 50%; } .estrella:nth-child(10) { top: 12%; left: 85%; }

@keyframes parpadeo {
  0%, 100% { opacity: 0.2; transform: scale(1); }
  50% { opacity: 0.8; transform: scale(1.2); box-shadow: 0 0 8px rgba(255,255,255,0.6); }
}

.estrella-fugaz {
  position: absolute;
  width: 150px;
  height: 2px;
  background: linear-gradient(90deg, rgba(255,255,255,0.8), transparent);
  opacity: 0;
  z-index: 1;
}

.f1 { top: 35%; right: 20%; animation: fugaz-der-izq 7s infinite; animation-delay: 1s; }
.f2 { top: -45%; left: 20%; animation: fugaz-izq-der 9s infinite; animation-delay: 4s; }
.f3 { top: 25%; right: 20%; animation: fugaz-der-izq 11s infinite; animation-delay: 7s; }

@keyframes fugaz-der-izq {
  0% { transform: translateX(0) translateY(0) rotate(160deg) scale(0); opacity: 0; }
  5% { opacity: 1; transform: translateX(-300px) translateY(150px) rotate(160deg) scale(1); }
  10% { opacity: 0; transform: translateX(-600px) translateY(300px) rotate(160deg) scale(0); }
  100% { opacity: 0; }
}

@keyframes fugaz-izq-der {
  0% { transform: translateX(0) translateY(0) rotate(-20deg) scale(0); opacity: 0; }
  5% { opacity: 1; transform: translateX(300px) translateY(150px) rotate(-20deg) scale(1); }
  10% { opacity: 0; transform: translateX(600px) translateY(300px) rotate(-20deg) scale(0); }
  100% { opacity: 0; }
}

.flor-4{ top: 100px; left: 10px; transform: translateX(-50%) rotate(-12deg); width:min(40vw, 220px) !important;  z-index: 6; }
.flor-5{ bottom: 90px; transform: translateX(-50%) rotate(-12deg); opacity: 0 !important; right: 10px; width: min(46vw, 240px); z-index: 8; }
.flor-6{ top: 420px; transform: translateX(-50%) rotate(-12deg); right: -120px; width: min(34vw, 180px) !important; z-index: 3; }

.portada-xv{
  width:100%;
  min-height:100vh;
  position: relative;
  display:flex;
  flex-direction:column;
  align-items:center;
  justify-content:flex-start;
  padding:48px 16px 56px;
  background-image: 
    linear-gradient(to bottom, rgba(0, 0, 0, 0.516) 60%, rgba(26, 29, 81, 0.7) 85%, rgba(31, 33, 61, 0.642) 100%),
    url('@/assets/Diseño sin título (7).jpg');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  z-index: 1;
  overflow: hidden;
}

.imagen-xv-wrapper{
  width: min(92vw, 360px);
  height: calc(min(92vw, 360px) * 1.5);
  margin-top: 6px;
  border-radius: 180px 180px 0 0;
  overflow: hidden;
  z-index: 2;
  background:#fff;
  box-shadow: 0 12px 40px rgba(0,0,0,.18), 0 2px 8px rgba(0,0,0,.06);
}

.imagen-xv{ width:100%; height:100%; object-fit:cover; display:block; }

.texto-xv{ max-width: 620px; text-align:center; margin-top: 22px; padding: 0 8px; z-index: 5;}

.frase-bendicion{
  font-family: "Playfair Display", serif;
  font-size: clamp(18px, 2.6vw, 24px);
  color:#eeeee8;
  line-height:1.5;
  margin: 20px 0 10px;
}

.separador-elegante{
  width:110px;
  height:2px;
  margin:12px auto 16px;
  background: linear-gradient(90deg, transparent, #d9b7c6, transparent);
  border-radius: 2px;
}

.nombre-protagonista{
  font-family: "titulos", cursive;
  font-size: 44px;
  color:#d8af71;
  margin: 0 0 8px 0;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.35);
  line-height:1.1;
}

.parrafo-presentacion{
  font-family: "quote", sans-serif;
  font-size: clamp(16px, 2.6vw, 18px);
  color:#fbfbfb;
  line-height:1.7;
  margin-top: 6px;
}

.flor{ position:absolute; width:min(44vw, 240px); z-index:10; transform-origin:center; opacity: 0.65; 
  
  /* Filtros para quitar el tono "caricatura": 
     - Saturate: baja la intensidad del color.
     - Brightness: lo hace un poco más sobrio.
     - Contrast: suaviza los bordes. */
 filter:
    saturate(0.7)
    brightness(0.95)
    contrast(0.9)
    blur(0.3px);  
  /* Mezcla suave con los colores de atrás */
 }
.flor-1{ top:-20px; left:-80px; z-index:5; }
.flor-2{ top:70px; right:-40px; transform: rotate(-70deg); z-index:1; width:min(40vw, 220px) !important;  }
.flor-3{ bottom:-100px; left:-80px; transform: rotate(-30deg); z-index:9;}

.bola{ position:absolute; width:120px; animation: girar 10s linear infinite; opacity:0 !important; z-index:1; }
.bola-izquierda{ left:-20px; bottom:-50px; z-index:9;}
@keyframes girar{ from{transform:rotate(0)} to{transform:rotate(360deg)} }

@media (min-width: 992px){
  .portada-xv{ padding-top:64px; }
  .imagen-xv-wrapper{ margin-top: 0; }
}
</style>